var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataUploadLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons/fi:loader"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.001 15.0015V18.3355",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5342 13.5347L15.893 15.8935",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.1084 15.8935L6.46721 13.5347",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.001 10.001H18.335",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.66699 10.001H5.001",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.5342 6.46769L15.893 4.10889",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.1084 4.10889L6.46721 6.46769",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.001 1.66699V5.001",
    stroke: "#3D3D3D",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUploadLoader);
export default __webpack_public_path__ + "static/media/data-upload-loader.228600042c77795838d5c9eed0696e19.svg";
export { ForwardRef as ReactComponent };